import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { HeroBlueprint } from './HeroBlueprint';
export function Hero() {
  return <section className="relative overflow-hidden border-b border-white/10 bg-ink pt-8 lg:pt-14" data-id="element-127" data-mp="jnx6pltxdxh7">
      <div className="absolute inset-0 bp opacity-90" aria-hidden="true" data-id="element-128" data-mp="epdlxor2irqf" />
      <div className="absolute -right-52 -top-40 h-[46rem] w-[46rem] rounded-full bg-navy-700/35 blur-[130px]" aria-hidden="true" data-id="element-129" data-mp="aoto0iyo7k38" />
      <div className="absolute -left-40 top-1/2 h-[30rem] w-[30rem] rounded-full bg-forge-orange/[0.09] blur-[120px]" aria-hidden="true" data-id="element-130" data-mp="5nvxnj3ibjqn" />

      <div className="relative mx-auto max-w-8xl px-5 pb-10 sm:px-8 lg:px-10 lg:pb-16" data-id="element-131" data-mp="3rwot9ytpkneq">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10" data-id="element-132" data-mp="3rz1jez9me42v">
          <div className="min-w-0 lg:col-span-5" data-id="element-133" data-mp="1v3lugff070j2">
            <motion.p initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.45
          }} className="inline-flex items-center gap-2.5 rounded-full border border-white/12 bg-white/[0.04] px-4 py-2 font-mono text-[11.5px] uppercase tracking-[0.16em] text-mist-200" data-id="element-134" data-mp="1q4sjatn6vlm2">
              <span className="h-1.5 w-1.5 rotate-45 bg-forge-orange" aria-hidden="true" data-id="element-135" data-mp="1d097mzyt7aao" />
              Custom web systems since 2002
            </motion.p>

            <motion.h1 initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.05
          }} className="mt-5 font-display text-[2rem] font-extrabold leading-[1.07] tracking-[-0.02em] text-white sm:text-[2.7rem] lg:text-[3.05rem]" data-id="element-136" data-mp="25nvech3c2v1r">
              Built for the business
              <span className="mt-1.5 block text-forge-orange" data-id="element-137" data-mp="2ol6ctzh55kg5">behind the website.</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="mt-5 max-w-xl text-[15px] leading-relaxed text-mist-200 sm:text-[16px]" data-id="element-138" data-mp="2tcob2frs56xf">
              WebsiteForge brings the website, search strategy, ecommerce, lead flow, and business integrations under one
              accountable team—then keeps the system current as the company evolves.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.16
          }} className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-139" data-mp="2kaavnhis85d0">
              <Link to="/#get-started" className="group inline-flex items-center justify-center gap-2 rounded-xl bg-forge-orange px-6 py-3.5 text-[15px] font-bold text-ink shadow-ember transition-transform hover:-translate-y-0.5" data-id="element-140" data-mp="26ie3xel0zxh5">
                Discuss Your Project
                <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-141" data-mp="c2p69rx63sps" />
              </Link>
              <Link to="/#solutions" className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/18 px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:border-forge-cyan/60 hover:bg-white/5" data-id="element-142" data-mp="gz5xww3ksp7m">
                Explore the Approach
              </Link>
            </motion.div>

            <p className="mt-6 flex items-start gap-2.5 text-[13.5px] leading-snug text-mist-300" data-id="element-143" data-mp="3ugyeaaufufgv">
              <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forge-green" aria-hidden="true" data-id="element-144" data-mp="2b1ka6jdr3vp" />
              Custom-built. Managed after launch. Backed by a 30-day money-back guarantee.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.12
        }} className="min-w-0 lg:col-span-7" data-id="element-145" data-mp="36q2jd4uor45e">
            <HeroBlueprint data-id="element-146" data-mp="2mo7zjbcgyqq6" />
          </motion.div>
        </div>
      </div>
    </section>;
}